/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, useMemo, BaseSyntheticEvent} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {GET, PUT, DELETE, POST} from '../../../../services/api'
import useModals from '../../../../hooks/useModals'
import {Loading} from '../../../../components/Loading/Loading'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import Swal from 'sweetalert2'
import useAuth from '../../../../hooks/useAuth'
import {i18n} from '../../../../translate/i18n'
import {Dropdown} from 'react-bootstrap'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {Input} from '../../../../components/Input/Input'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import {MetaType, NewDatatable, OrderType} from '../../../../components/NewDataTable/NewDataTable'
import {useSwitchStatus} from '../../../../components/Datatable/SwitchStatus'
import usePluginSpace from '../../../../hooks/usePluginSpace'
import {SaleDatesLoteModal} from '../../../../components/Modals/SaleDatesLote/SaleDatesLoteModal'

type ProductType = {
  id: number
  selected: boolean
  name: string
  images: Array<string>
  code: string
  order: string
  status: boolean
}

type ImageType = {
  path: string
  imgsuffix: string
  productId: number
  typeimg: string
  order: number
}

type PluginconfigType = {
  id: number
  name: string
  plugintemplateId: number
  deleted: string
}

type categories = {
  value: string
  select: string
}

type filter = {
  classificationId?: string
  status?: boolean
  order?: OrderType
  noGroup?: boolean
  customerGroupId?: number[]
}

const ProdutosContent: FC = () => {
  const navigate = useNavigate()
  const {integrations} = usePluginsSpace()
  const {loginInfo} = useAuth()
  const {switchStatus} = useSwitchStatus()
  const {showDeleteModal, showWrapperModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [products, setProducts] = useState<ProductType[]>([])
  const [id, setId] = useState<number | null>(null)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)
  const [fileToImport, setFileToImport] = useState<File | null>(null)
  const [hasIntegration, setHasIntegration] = useState(false)
  const [categoria, setCategoria] = useState<categories[]>([])
  const [qtdSelected, setQtdSelected] = useState(0)
  const [registeredGroups, setRegisteredGroups] = useState([])
  const [selectedGroup, setSelectedGroup] = useState<number[]>([])
  const [action, setAction] = useState<'alterLote' | 'importProduct'>('importProduct')
  const [changeStatusLote, setChangeStatusLote] = useState(false)
  const [TypeModal, setTypeModal] = useState('')
  const [checkedAll, setCheckedAll] = useState(false)
  const [removeGroups, setRemoveGroups] = useState(false)
  const [showSaleDatesModal, setShowSaleDatesModal] = useState(false)

  // Nova implementação: Carrega filtros APENAS UMA VEZ usando useMemo
  const savedFilters = useMemo(() => {
    try {
      const storageKey = `filtros_produtos_commons_${loginInfo.pluginspaceId}`
      const saved = localStorage.getItem(storageKey)
      if (saved) {
        console.log('🔄 Carregando filtros salvos (Commons):', JSON.parse(saved))
        return JSON.parse(saved)
      }
    } catch (error) {
      console.error('Erro ao carregar filtros:', error)
    }
    return null
  }, [loginInfo.pluginspaceId])

  // Estados dos filtros com valores do localStorage ou padrão
  const [filterStatus, setFilterStatus] = useState<any>(
    savedFilters?.filterStatus || {
      label: 'Ativo',
      value: 1,
    }
  )
  const [filterCategoria, setFilterCategoria] = useState<any>(
    savedFilters?.filterCategoria || {
      label: 'TODAS',
      value: 0,
    }
  )
  const [filterGroup, setFilterGroup] = useState<any[]>([])
  const [options, setOptions] = useState([
    {
      icon: 'fas fa-pen',
      title: `${i18n.t(`general.edit`)} ${i18n.t(`smart_order.product`)}`,
      href:
        loginInfo.plugintype === 'varejo'
          ? `/product_varejo/editar/id`
          : `/product_fashion/editar/id`,
      action: (item: any) => {
        navigate(
          loginInfo.plugintype === 'varejo'
            ? `/product_varejo/editar/${item.id}`
            : `/product_fashion/editar/${item.id}`
        )
      },
    },
  ])
  const {getPluginSpace} = usePluginSpace()
  const [attGroup, setAttGroup] = useState(false)
  const [idClickGroup, setIdClickGroup] = useState<number | null>(null)
  const [isWholeSaler, setIsWholeSaler] = useState(false)

  // codigo usado para salvar o filtro e tudo no localStorage

  const [groupQuery, setGroupQuery] = useState('')
  const filteredGroups = registeredGroups.filter((g: any) =>
    g.name.toLowerCase().includes(groupQuery.toLowerCase())
  )

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (attGroup && idClickGroup !== null) {
      setSelectedGroup((prev: number[]) => prev.filter((id) => id !== idClickGroup))
      setAttGroup(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attGroup, idClickGroup])

  const init = async () => {
    setLoading(true)
    await filterProdutos()
    await getCustomersGroups()
    setLoading(false)
  }

  async function getCustomersGroups() {
    try {
      const thisPluginsSpace = await getPluginSpace(true)

      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler

      if (isWholeSaler) {
        setIsWholeSaler(true)
        const res = await GET('/customer_groups')
        if (res && res.data) {
          setRegisteredGroups(res.data)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getCategories = async () => {
    try {
      setLoading(true)
      const resCategorias = await POST(`/classification/filter`)

      const categories = [
        {
          value: 0,
          select: 'TODAS',
        },
        ...resCategorias.data.map((el: any) => {
          return {
            value: el.id,
            select: el.name,
          }
        }),
      ]

      categories.sort((a: any, b: any) => {
        if (a.value === 0) return -1
        if (b.value === 0) return 1

        return a.select.toUpperCase() > b.select.toUpperCase()
          ? 1
          : a.select.toUpperCase() < b.select.toUpperCase()
          ? -1
          : 0
      })
      setCategoria(categories)

      setLoading(false)
    } catch (error) {
      console.log(error)
    }
  }

  const getProducts = async (take: number = 10, page: number = 1, search: string = '') => {
    try {
      const res = await GET(`/product?page=${page}&take=${take}&search=${search}`)
      const newProducts = res.data.map((row: any) => {
        let imgProduct = ''
        if (row.images.length > 0 && process.env.REACT_APP_AWS_S3_URL) {
          let imgFind = row.images.find((img: ImageType) => img.typeimg === 'imgsmall')
          if (imgFind) {
            imgProduct =
              imgFind.path.substring(7, imgFind.path.length) + '/' ===
              process.env.REACT_APP_AWS_S3_URL.substring(7, process.env.REACT_APP_AWS_S3_URL.length)
                ? imgFind.path + '/' + imgFind.imgsuffix
                : imgFind.path
          }
        }
        return {
          id: row.id ? row.id : '',
          selected: false,
          order: row.order ?? 0,
          img: imgProduct ? imgProduct : '',
          name: row.name ? row.name : '',
          code: row.code,
          category: row.classification && row.classification.name ? row.classification.name : '',
          status: row.status ? row.status : false,
        }
      })
      setProducts(newProducts)
      setMeta(res.meta)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const verifyIntegration = async () => {
    try {
      setLoading(true)
      const integrationTemplateIds = [23, 15, 45, 48, 104]
      const totvsIntegration = integrations.filter(
        (pluginconfig: any) => {
          if (!integrationTemplateIds.includes(pluginconfig?.plugintemplateId)) {
            return false
          }

          const able = pluginconfig?.content?.able
          return able === '1' || able === 1
        }
      )

      console.info('[Produtos/index] Integracoes encontradas para hasIntegration:', {
        integrationTemplateIds,
        hasIntegration: totvsIntegration.length > 0,
        matched: totvsIntegration.map((item: any) => ({
          id: item.id,
          name: item.name,
          plugintemplateId: item.plugintemplateId,
          able: item?.content?.able ?? null,
        })),
      })

      if (totvsIntegration && totvsIntegration.length > 0) {
        setHasIntegration(true)
      } else {
        setHasIntegration(false)
        setOptions([
          {
            icon: 'fas fa-pen',
            title: `${i18n.t(`general.edit`)} ${i18n.t(`smart_order.product`)}`,
            href:
              loginInfo.plugintype === 'varejo'
                ? `/product_varejo/editar/id`
                : `/product_fashion/editar/id`,
            action: (item: any) => {
              navigate(
                loginInfo.plugintype === 'varejo'
                  ? `/product_varejo/editar/${item.id}`
                  : `/product_fashion/editar/${item.id}`
              )
            },
          },
          {
            icon: 'fas fa-trash',
            action: (item) => {
              showDeleteModal('Excluir produto')
              setId(item.id)
            },
            href: '',
            title: 'Excluir produto',
          },
        ])
      }
      setLoading(false)
    } catch (e) {
      setHasIntegration(false)
      setLoading(false)
      console.log(e)
    }
  }

  function b64toBlob(base64: string, contentType: string) {
    const byteCharacters = atob(base64)
    const byteArrays = []

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512)
      const byteNumbers = new Array(slice.length)
      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j)
      }
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, {type: contentType})
  }

  const importProducts = async () => {
    try {
      if (!fileToImport) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se foi selecionado um arquivo!',
        })
        return
      }

      setLoading(true)
      const formData = new FormData()
      formData.append('file', fileToImport)

      const importRes = await POST('/product/import', formData)
      setLoading(false)

      if (importRes.success === true && !importRes.fileBase64) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Importação realizada com sucesso!',
        }).then(async () => await getProducts())
      } else if (importRes.fileBase64) {
        const blob = b64toBlob(
          importRes.fileBase64,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
        const url = window.URL.createObjectURL(blob)

        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          html: `
            <div style="margin-bottom: 1em;">
              Alguns produtos ou variações apresentaram <b>erros na importação</b>.<br>
              Você pode baixar o arquivo com os detalhes abaixo.
            </div>
            <button id="baixar-erros" class="swal2-confirm swal2-styled" style="display:inline-block; margin-right: 1em;">Baixar erros</button>
            <button id="fechar-alerta" class="swal2-cancel swal2-styled" style="display:inline-block; background:#eee; color:#333;">Fechar</button>
          `,
          showConfirmButton: false,
          didOpen: () => {
            document.getElementById('baixar-erros')?.addEventListener('click', () => {
              const a = document.createElement('a')
              a.href = url
              a.download = 'erros-importacao.xlsx'
              document.body.appendChild(a)
              a.click()
              a.remove()
              window.URL.revokeObjectURL(url)
              Swal.close()
            })
            document.getElementById('fechar-alerta')?.addEventListener('click', () => {
              Swal.close()
            })
          },
        }).then(async () => await getProducts())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao importar arquivo!',
        }).then(async () => await getProducts())
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro inesperado',
        text: e?.message || 'Ocorreu um erro inesperado',
      }).then(async () => await getProducts())
    }

    setFileToImport(null)
  }

  const deleteProduct = async () => {
    try {
      setLoading(true)
      const markRes = await DELETE(`/product/${id}`)
      if (markRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Produto deletado',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getProducts())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar o produto!',
        }).then(async () => await getProducts())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar o produto!',
      }).then(async () => await getProducts())
      console.log(e)
    }
  }

  const switchSelected = async (Id: number, status: boolean) => {
    try {
      const newProducts = products.map((el) => {
        if (el.id === Id) {
          el.selected = !el.selected
        }
        return el
      })

      // eslint-disable-next-line eqeqeq
      const filterdArray = newProducts.filter((el) => el.selected == true)
      setQtdSelected(filterdArray.length)
      setProducts(newProducts)
      // Atualiza checkedAll se todos estiverem selecionados
      setCheckedAll(filterdArray.length === newProducts.length && newProducts.length > 0)
    } catch (e) {
      console.log(e)
    }
  }

  // Função para salvar filtros no localStorage
  const saveFiltersToStorage = () => {
    try {
      const filtersToSave = {
        filterStatus,
        filterCategoria,
        filterGroup,
      }
      const storageKey = `filtros_produtos_commons_${loginInfo.pluginspaceId}`
      localStorage.setItem(storageKey, JSON.stringify(filtersToSave))
      console.log('💾 Filtros salvos (Commons):', filtersToSave)
    } catch (error) {
      console.error('Erro ao salvar filtros:', error)
    }
  }

  function selecteAll(checked: boolean) {
    try {
      setLoading(true)
      const newProducts = products.map((el) => {
        el.selected = checked
        return el
      })
      setProducts(newProducts)
      // eslint-disable-next-line eqeqeq
      const filterdArray = newProducts.filter((el) => el.selected == true)
      setQtdSelected(filterdArray.length)
      setCheckedAll(checked)
      setTimeout(() => {
        setLoading(false)
      }, 1)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const filterProdutos = async (
    take: number = 100,
    page: number = 1,
    search: string = '',
    order: OrderType = {field: 'name', type: 'ASC'},
    clearData: boolean = false
  ) => {
    if (!filterCategoria || !filterStatus) {
      Swal.fire({
        icon: 'error',
        title: 'Filtros não selecionados',
        text: 'Selecione corretamente os filtros',
      })
    } else {
      try {
        setQtdSelected(0)

        // eslint-disable-next-line eqeqeq, no-self-assign
        const newStatus = filterStatus.value == '1' ? true : false

        const filter: filter = {
          status: newStatus,
          classificationId: filterCategoria.value,
          order,
        }

        if (isWholeSaler && filterGroup && filterGroup.length > 0) {
          const selectedValues = filterGroup.map((g: any) => g.value ?? g)
          if (selectedValues.includes(-1)) {
            filter['noGroup'] = true
          }
          const groupIds = selectedValues.filter((v: number) => v > 0)
          if (groupIds.length > 0) {
            filter['customerGroupId'] = groupIds
          }
        }

        // eslint-disable-next-line eqeqeq, no-self-assign
        filterStatus.value == '2' ? delete filter['status'] : (filter['status'] = filter['status'])

        // eslint-disable-next-line no-self-assign
        filterCategoria.label.toUpperCase() === 'GERAL'
          ? // eslint-disable-next-line no-self-assign
            delete filter['classificationId']
          : // eslint-disable-next-line no-self-assign
            (filter['classificationId'] = filter['classificationId'])

        const filteredProducts = await POST(
          `product/filter_admin?page=${page}&take=${take}&search=${search}`,
          filter
        )

        const newFilteredProducts = filteredProducts.data.map((row: any) => {
          let imgProduct = ''
          if (row.images.length > 0 && process.env.REACT_APP_AWS_S3_URL) {
            let imgFind = row.images.find((img: ImageType) => img.typeimg === 'imgsmall')
            if (imgFind) {
              imgProduct =
                imgFind.path.substring(7, imgFind.path.length) + '/' ===
                process.env.REACT_APP_AWS_S3_URL.substring(
                  7,
                  process.env.REACT_APP_AWS_S3_URL.length
                )
                  ? imgFind.path + '/' + imgFind.imgsuffix
                  : imgFind.path
            }
          }
          return {
            id: row.id,
            selected: false,
            code: row.code,
            order: row.order ?? 0,
            img: imgProduct,
            name: row.name,
            category: row.classification && row.classification.name,
            averageTime: row.productTimer ? row.productTimer.averageTime : '00:00:00',
            status: row.status,
          }
        })

        setProducts(newFilteredProducts)
        setMeta(filteredProducts.meta)
        return newFilteredProducts
      } catch (error) {
        setLoading(false)
        console.log(error)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Um erro ocorreu ao filtrar os produto',
        }).then(async () => await getProducts())
      }
    }
  }

  const changeInLote = async (typeModal: string) => {
    try {
      const productsToUpdate = products.filter((el) => el.selected === true)

      setLoading(true)
      // eslint-disable-next-line eqeqeq
      if (typeModal == 'Status') {
        const switchProduct = await PUT(`/product/massiveUpdate`, {
          status: changeStatusLote,
          data: productsToUpdate,
        })
        setChangeStatusLote(false)
        if (switchProduct.success) {
          const newProducts = products.map((product) => {
            if (product.selected) {
              product.status = changeStatusLote
            }

            product.selected = false
            return product
          })
          setCheckedAll(false)
          setProducts(newProducts)
          setQtdSelected(0)
        }
        // eslint-disable-next-line eqeqeq
      } else if (typeModal == 'Grupo') {
        // Só exige grupo selecionado se NÃO for remoção total
        if (!removeGroups && (!selectedGroup || selectedGroup.length === 0)) {
          Swal.fire({
            icon: 'error',
            title: 'Grupo não selecionado',
            text: 'Selecione ao menos um grupo para alterar!',
          })
          setLoading(false)
          return
        }
        if (!productsToUpdate || productsToUpdate.length === 0) {
          Swal.fire({
            icon: 'error',
            title: 'Nenhum produto selecionado',
            text: 'Selecione ao menos um produto para alterar!',
          })
          setLoading(false)
          return
        }
        const res = await POST(`/product-customer-group/bulk-group`, {
          productIds: productsToUpdate.map((p) => p.id),
          customerGroups: selectedGroup,
          remove: removeGroups,
        })
        if (res.success) {
          const newProducts = products.map((product) => {
            product.selected = false
            return product
          })
          setCheckedAll(false)
          setProducts(newProducts)
          setQtdSelected(0)
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: removeGroups
              ? 'Remoção de grupos realizada com sucesso!'
              : 'Associação de grupos realizada com sucesso!',
          })
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro ocorreu ao atualizar os produtos',
      })
    }
  }

  useEffect(() => {
    verifyIntegration()
    getCategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const canShowCreateImport = !hasIntegration
  const canShowDeleteAll = false
  const canShowToolbarDropdown = canShowCreateImport || canShowDeleteAll

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`smart_order.product`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `smart_order.here_are_listed_the_products_along_with_their_respective_actions`
                  )}
                </span>
              </h3>
              <div className='card-toolbar'>
                {/* <Button
                  text='Migração'
                  color='primary'
                  iconColor='#FFF'
                  icon='bi bi-arrow-left-right'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {}}
                  btnClass='mb-5 fw-bolder me-5'
                /> */}
                {canShowCreateImport && (
                  <Button
                    text={i18n.t(`buttons.register_product`)}
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-plus'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      navigate(
                        loginInfo.plugintype === 'varejo'
                          ? '/product_varejo/criar'
                          : '/product_fashion/criar'
                      )
                    }}
                    btnClass='mb-5 fw-bolder'
                  />
                )}
                {canShowToolbarDropdown && (
                  <Dropdown
                    className='btn btn-primary btn-sm fw-bolder me-5 p-0 mb-5'
                    style={{marginLeft: '1em'}}
                  >
                    <Dropdown.Toggle variant='default' size='sm'>
                      <i className='bi bi-three-dots fs-4 p-0'></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='p-0'>
                      {canShowCreateImport && (
                        <Dropdown.Item
                          onClick={() => {
                            showWrapperModal('Importar planilha')
                          }}
                          className='p-0 d-flex flex-row justify-content-center'
                        >
                          <div
                            className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                            style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              className='bi bi-filetype-csv'
                              viewBox='0 0 16 16'
                              style={{color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em'}}
                            >
                              <path
                                fill-rule='evenodd'
                                d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z'
                              />
                            </svg>
                            <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                              Importar planilha
                            </p>
                          </div>
                        </Dropdown.Item>
                      )}

                      {canShowCreateImport && canShowDeleteAll && <Dropdown.Divider />}

                     {/*  {canShowDeleteAll && (
                        <>
                          <Dropdown.Item
                            onClick={() => {
                              Swal.fire({
                                icon: 'warning',
                                title: `Atenção!`,
                                html: `
                              Cuidado ao realizar a exclusão, os dados não poderão ser <b>restaurados!<b/>
                              <div style="margin-top: 8">Digite <b>excluir</b> para confirmar!</div>`,
                                showCloseButton: true,
                                showConfirmButton: true,
                                confirmButtonColor: '#dc3741',
                                confirmButtonText: 'Excluir',
                                showCancelButton: false,
                                input: 'text',
                                inputPlaceholder: 'excluir',
                                preConfirm: (text) => {
                                  setConfirmText(text)
                                },
                              }).then(async (res) => {
                                if (res.isConfirmed && res.value && res.value === 'excluir') {
                                  await deleteAllProduct()
                                } else {
                                  Swal.close()
                                }
                              })
                            }}
                            className='p-0 d-flex flex-row justify-content-center'
                          >
                            <div
                              className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                              style={{color: '#F64E60', backgroundColor: '#FFE2E5', width: '90%'}}
                            >
                              <i
                                className='bi bi-x'
                                style={{color: '#F64E60', fontSize: '1.5rem', marginRight: '0.5em'}}
                              ></i>
                              <p style={{color: '#F64E60', fontSize: '1rem'}} className='m-0'>
                                Excluir tudo
                              </p>
                            </div>
                          </Dropdown.Item>
                        </>
                      )} */}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
            <div className='card-body'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-50 '>
                  <div className='flex-grow-1 align-items-end  justify-content-start me-5'>
                    <span className='align-self-start'>Categorias</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={categoria}
                      placeholder={'Categoria'}
                      search={true}
                      value={filterCategoria}
                      change={(value: any) => setFilterCategoria(value)}
                    />
                  </div>

                  <div className='align-items-center me-5 justify-content-between flex-grow-1'>
                    <span className='align-self-start'>Status</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={[
                        {
                          value: 1,
                          select: 'Ativo',
                        },
                        {
                          value: 0,
                          select: 'Inativo',
                        },
                        {
                          value: 2,
                          select: 'Ambos',
                        },
                      ]}
                      value={filterStatus}
                      placeholder={'Status do Produto'}
                      search={true}
                      change={(value: any) => setFilterStatus(value)}
                    />
                  </div>

                  {/* Filtro de Grupo, só aparece se isWholeSaler */}
                  {isWholeSaler && (
                    <div className='align-items-center me-5 justify-content-between flex-grow-1'>
                      <span className='align-self-start'>Grupo</span>
                      <Input
                        inputAttr={{
                          type: 'multiselect',
                        }}
                        options={
                          filterGroup.some((g: any) => g.value === -1)
                            ? [{value: -1, select: 'SEM GRUPO'}]
                            : [
                                ...registeredGroups.map((g: any) => ({
                                  value: g.id,
                                  select: g.name,
                                })),
                                {value: -1, select: 'SEM GRUPO'},
                              ].filter((opt) => filterGroup.length === 0 || opt.value !== -1)
                        }
                        value={filterGroup}
                        placeholder={'TODOS'}
                        search={true}
                        change={(selected: any[]) => {
                          if (selected.some((g: any) => g.value === -1)) {
                            setFilterGroup([{value: -1, select: 'SEM GRUPO', label: 'SEM GRUPO'}])
                          } else {
                            setFilterGroup(
                              selected
                                .filter((g: any) => g.value !== -1)
                                .map((g: any) => ({
                                  ...g,
                                  label: g.select || g.label,
                                }))
                            )
                          }
                        }}
                      />
                    </div>
                  )}
                </div>

                <div
                  className='d-flex align-items-end w-50 justify-content-end h-100'
                  style={{
                    marginTop: '48px',
                  }}
                >
                  <Button
                    text='Filtrar'
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-filter'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={async () => {
                      // Salva os filtros no localStorage
                      saveFiltersToStorage()

                      setLoading(true)
                      await filterProdutos(100, 1, '', {field: 'name', type: 'ASC'}, true)
                      setLoading(false)
                    }}
                    btnClass='mb-0 fw-bolder'
                  />
                </div>
              </div>
              <div className='pt-4 d-flex align-items-center gap-2'>
                {(loginInfo.profile === 'admin' || loginInfo.profile === 'owner') && isWholeSaler && (
                  <Button
                    text='Editar Datas de Venda'
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{type: 'button'}}
                    click={() => setShowSaleDatesModal(true)}
                    btnClass='fw-bolder'
                  />
                )}
                <div>
                  <Dropdown className='btn btn-primary btn-sm fw-bolder me-5 p-0'>
                    {qtdSelected === 0 ? (
                      <Dropdown.Toggle variant='sm' disabled>
                        <span style={{color: '#FFF', width: '90%'}}>
                          Alterar em Lote ({qtdSelected})
                        </span>
                      </Dropdown.Toggle>
                    ) : (
                      <Dropdown.Toggle variant='sm'>
                        <span style={{color: '#FFF', width: '90%'}}>
                          Alterar em Lote ({qtdSelected})
                        </span>
                      </Dropdown.Toggle>
                    )}
                    <Dropdown.Menu className='p-0'>
                      <Dropdown.Item
                        size='sm'
                        onClick={() => {
                          setAction('alterLote')
                          setTypeModal('Status')
                          showWrapperModal('Alterar Produtos')
                        }}
                        className='p-0 d-flex flex-row justify-content-center'
                      >
                        <div
                          className='btn m-2 btn-sm d-flex flex-row justify-content-center align-items-center'
                          style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                        >
                          <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                            Status
                          </p>
                        </div>
                      </Dropdown.Item>
                      {isWholeSaler && (
                        <Dropdown.Item
                          size='sm'
                          onClick={() => {
                            setAction('alterLote')
                            setTypeModal('Grupo')
                            showWrapperModal('Alterar Grupo dos Produtos')
                          }}
                          className='p-0 d-flex flex-row justify-content-center'
                        >
                          <div
                            className='btn m-2 btn-sm d-flex flex-row justify-content-center align-items-center'
                            style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                          >
                            <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                              Alterar Grupo
                            </p>
                          </div>
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                {/* <div className='mt-0'>
                  <Input
                    label={`${i18n.t('smart_order.selectAll')}`}
                    checked={checkedAll}
                    size='small'
                    change={(checked: boolean) => {
                      setCheckedAll(checked)
                      selecteAll(checked)
                    }}
                    inputAttr={{
                      type: 'checkbox',
                    }}
                  />
                </div> */}

                {/* <Button
                  text={'Selecionar todos'}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    selecteAll()
                  }}
                  btnClass='fw-bolder me-5'
                /> */}
              </div>

              <NewDatatable
                data={products}
                headers={[
                  {
                    key: 'Selecionado',
                    value: 'selected',
                    type: 'checkBox',
                    action: (item) => switchSelected(item.id, item.status),
                  },
                  {key: i18n.t(`smart_order.code`), value: 'code', type: 'default'},
                  {key: i18n.t(`smart_order.image`), value: 'img', type: 'image', noOrder: true},
                  {key: i18n.t(`smart_order.name`), value: 'name', type: 'default'},
                  {
                    key: i18n.t(`smart_order.category`),
                    value: 'category',
                    type: 'default',
                    noOrder: true,
                  },
                  {
                    key: i18n.t(`general.active`),
                    value: 'status',
                    type: 'check',
                    action: (item) =>
                      switchStatus({
                        endpoint: 'product',
                        Id: item.id,
                        status: item.status,
                      }),
                  },
                  {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
                ]}
                options={options}
                color='primary'
                meta={meta}
                onChangeData={async (take, page, search, order) =>
                  await filterProdutos(take, page, search, order)
                }
                search
                selectAllChecked={checkedAll}
                onSelectAll={selecteAll}
              />
            </div>
          </div>
          <ModalDelete confirmAction={() => deleteProduct()} text='delete_product_observation' />
          <ModalWrapper
            confirmAction={() =>
              action === 'importProduct' ? importProducts() : changeInLote(TypeModal)
            }
          >
            {action === 'importProduct' && (
              <>
                <div className='flex-grow-1'>
                  <p className='pt-4'>{i18n.t(`general.attention`)}</p>
                  <p>
                    Este modelo de planilha deve ser utilizado para importar produtos e variações.
                  </p>
                  <div
                    style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          maxWidth: '50em',
                        }}
                      >
                        Preencha os campos conforme os cabeçalhos indicados na primeira linha da
                        planilha. Certifique-se de que os dados estejam completos e corretos antes
                        de realizar o envio.
                      </div>
                    </div>
                  </div>
                  <div className='mt-4 mb-4'>
                    <Button
                      text={'Modelo'}
                      color='primary'
                      iconColor='#FFF'
                      size='small'
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        window.open('/file/modelo-produtos-variacoes.xlsx', '')
                      }}
                      btnClass='fw-bolder me-5'
                    />
                  </div>
                </div>
                {/* <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: '1em',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '50em',
                      }}
                    >
                      Para importar produtos com variações únicas: categoria, nome, codigo,
                      descricao, especificacao_tecnica, status, ordem, preco, preco_promocional,
                      estoque
                    </div>
                    <div style={{marginLeft: '1em'}}>
                      <Button
                        text={'Modelo'}
                        color='primary'
                        iconColor='#FFF'
                        size='small'
                        btnAttr={{
                          type: 'button',
                        }}
                        click={() => {
                          window.open('/file/modelo-produtos-variacao-unica.xlsx', '')
                        }}
                        btnClass='fw-bolder me-5'
                      />
                    </div>
                  </div> */}
                <br />
                <div className='flex-grow-1 text-center'>
                  <Input
                    inputAttr={{
                      type: 'file',
                    }}
                    acceptFile={'.xlsx,.xls'}
                    change={(value: BaseSyntheticEvent) =>
                      setFileToImport(value ? value.target.files[0] : null)
                    }
                  />
                </div>
              </>
            )}

            {action === 'alterLote' && (
              <>
                {TypeModal === 'Status' && (
                  <>
                    <div className='mt-1'>
                      <span>Os itens abaixo serão alterados</span>
                    </div>
                    <div
                      className='d-flex flex-column overflow-scroll'
                      style={{
                        height: '8rem',
                        border: '1px solid #949392',
                      }}
                    >
                      {/* eslint-disable-next-line array-callback-return */}
                      {products.map((elemento) => {
                        if (elemento.selected === true) {
                          return (
                            <span className='ms-2'>
                              {elemento.code} - {elemento.name}
                            </span>
                          )
                        }
                      })}
                    </div>
                  </>
                )}

                <div>
                  {TypeModal === 'Status' && (
                    <>
                      <div className='d-flex flex-column mt-2'>
                        <span>Status</span>
                        <Input
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checkSwift={true}
                          value={changeStatusLote}
                          change={(value: boolean) => {
                            setChangeStatusLote(value)
                          }}
                        />
                      </div>
                    </>
                  )}

                  {TypeModal === 'Grupo' && (
                    <>
                      <div
                        className='d-flex justify-content-between'
                        style={{height: 330, overflowY: 'scroll'}}
                      >
                        {filteredGroups.length === 0 ? (
                          <span className='text-muted mt-3'>Nenhum grupo cadastrado</span>
                        ) : (
                          <div className='mx-3 flex-grow-1'>
                            {/* Opção para remover grupos associados */}
                            <div className='mb-3 mt-5'>
                              <Input
                                inputAttr={{type: 'checkbox'}}
                                label='Remover grupos associados'
                                checked={removeGroups}
                                change={setRemoveGroups}
                                disabled={selectedGroup.length > 0}
                              />
                            </div>
                            {/* Campo de busca */}
                            <div className='mb-2'>
                              <Input
                                value={groupQuery}
                                inputAttr={{
                                  type: 'search',
                                  name: 'search',
                                }}
                                change={setGroupQuery}
                                placeholder={'Procurar grupo'}
                              />
                            </div>
                            {/* Tags dos grupos selecionados */}
                            {selectedGroup && selectedGroup.length > 0 && (
                              <div
                                className='mt-5'
                                style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}
                              >
                                {registeredGroups
                                  .filter((g: any) => selectedGroup.includes(g.id))
                                  .map((g: any) => (
                                    <div
                                      key={g.id}
                                      style={{
                                        color: '#000',
                                        backgroundColor: '#f1f2f4',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        minWidth: '30px',
                                        minHeight: '30px',
                                      }}
                                    >
                                      <span>{g.name}</span>
                                      <span
                                        style={{
                                          cursor: 'pointer',
                                          fontWeight: 'bold',
                                          marginLeft: 4,
                                          fontSize: 16,
                                          lineHeight: 1,
                                        }}
                                        onClick={() => {
                                          setAttGroup(true)
                                          setIdClickGroup(g.id)
                                        }}
                                      >
                                        ×
                                      </span>
                                    </div>
                                  ))}
                              </div>
                            )}
                            {/* Lista de grupos com checkbox */}
                            <div className='row mt-4'>
                              <div className='col-12'>
                                {filteredGroups.length === 0 ? (
                                  <span className='text-muted mt-3'>Nenhum grupo encontrado</span>
                                ) : (
                                  !attGroup &&
                                  filteredGroups.map((group: any) => (
                                    <Input
                                      key={`group-checkbox-${group.id}`}
                                      inputAttr={{type: 'checkbox'}}
                                      checked={selectedGroup.includes(group.id)}
                                      change={(value: boolean) => {
                                        if (value) {
                                          setSelectedGroup((prev: number[]) => [...prev, group.id])
                                        } else {
                                          setSelectedGroup((prev: number[]) =>
                                            prev.filter((id) => id !== group.id)
                                          )
                                        }
                                      }}
                                      label={group.name}
                                      disabled={removeGroups}
                                    />
                                  ))
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </ModalWrapper>
        </div>
      )}

      {loginInfo.pluginspaceId && (
        <SaleDatesLoteModal
          isOpen={showSaleDatesModal}
          onClose={() => setShowSaleDatesModal(false)}
          onSuccess={() => init()}
          pluginspaceId={loginInfo.pluginspaceId}
        />
      )}
    </>
  )
}

const Produtos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`smart_order.product`)}
      </PageTitle>
      <ProdutosContent />
    </>
  )
}

export {Produtos}
